import { IFormDataInput } from "../../model/IFormDataInput"
import { getPostalCodePattern } from "../../utils/patternHelper"
export const ReturnCustomerFormObject: IFormDataInput[] = [
    {
        Id: 'ReturnPolicyNumInput',
        Name: 'PolicyNumber',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'Policy Number.',
        Label: 'policyNumber',
        Required: false,
        ClassName: 'pt-2',
        Width: "w-[14rem] md:w-[17rem] lg:w-[20.5rem] border-[1.5px] border-gray-400",
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [{ type: '', error: '' }],
        ErrorMessage: '',
        Pattern: '',
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'ReturnPostalCodeInput',
        Name: 'PostalCode',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'Postal Code',
        Label: 'postalCode',
        Required: false,
        ClassName: 'pt-2 lg:h-36 md:h-[7rem] h-[7.7rem] lg:pt-9 pt-2',
        Width: 'lg:w-[12rem] md:w-[10rem] w-[8rem] border-[1.5px] border-gray-400',
        ErrorStyling: "lg:text-sm text-xs lg:w-44 md:w-36 w-28 pt-1 ml-0.5",
        MinWidth: 'min-w-[8rem]',
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'pattern', error: 'postalcodepatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getPostalCodePattern(),
        IsValid: true,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
]
export const ReturnCustomerDataObject = {
    PolicyNumber: '',
    PostalCode: '',
    IsReturnCustomer: false,
    ReturnCustomerFormDataInput: ReturnCustomerFormObject,
    ShowReturningCustomer: true
}